import React, { useEffect, useState } from "react";
// import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Spinner } from "react-bootstrap";
import { imageRender, thousandSeperate } from "../../../helpers";
// import { GET_ORDERS } from "../../../graphql/order/query";
import { useLazyQuery } from "@apollo/client";
import { GET_ORDERS_V2 } from "../../../graphql/order/query";
// import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
import PaginationsV1 from "../../../components/PaginationV1";
import * as XLSX from "xlsx";
import moment from "moment";
import { CREATED } from "../../../constants";

function LiveDetailSummary({ postDetailSummary, liveData, totalOrder, page, rowsPerPage, pageAll, handleChangePage }) {
    // const [liveOrderList, setLiveOrderList] = useState([]);
    // const [liveStockList, setLiveStockList] = useState([]);
    const [liveProductSummary, setLiveProductSummary] = useState([]);
    // const [totalAmount, setTotalAmount] = useState(0);
    // const [getOrderData, { data: orderData }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
    const [getAllOrders, { loading: loadingAllOrders }] = useLazyQuery(GET_ORDERS_V2, { fetchPolicy: "network-only" });
    // const [getLiveStockData, { data: liveStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        modifyData();
    }, [postDetailSummary])

    const modifyData = async () => {

        let _liveProductSummary = []

        // set post detail summary 
        _liveProductSummary = postDetailSummary.map((orders) => {
            return {
                stock: orders[0]?.postStock?.stock ?? {},
                count: orders?.reduce((sumAmount, order) => {
                    return sumAmount + order?.amount
                }, 0),
                price: orders[0]?.price,
                totalPrice: orders?.reduce((sumPrice, order) => {
                    return sumPrice + (order?.amount * order?.price)
                }, 0),
                currency: orders[0]?.currency ?? "ກີບ",
                cfMessage: orders[0]?.cfMessage
            }
        })
        setLiveProductSummary(_liveProductSummary)

        //set total price
        // let _newTotalPrice = _liveProductSummary?.reduce((sumPrice, order) => {
        //     return sumPrice + order?.totalPrice
        // }, 0)
        // setTotalAmount(_newTotalPrice);
    }

    const handleExportExcel = async () => {
        try {
            const result = await getAllOrders({
                variables: {
                    where: {
                        post: liveData?.id,
                        isDeleted: false,
                        status: CREATED
                    },
                    limit: 1000000, 
                    skip: 0,
                }
            });

            if (result?.data?.ordersV2?.data) {
                const allOrders = result.data.ordersV2.data;

                // Group orders by cfMessage
                const groupedOrders = Object.values(_.groupBy(allOrders, 'cfMessage'));

                const dataToExport = groupedOrders.map((orders, index) => {
                    const firstOrder = orders[0];
                    const stock = firstOrder?.postStock?.stock ?? {};
                    const count = orders.reduce((sum, order) => sum + (order?.amount || 0), 0);
                    const price = firstOrder?.price || 0;
                    const totalPrice = orders.reduce((sum, order) => sum + ((order?.amount || 0) * (order?.price || 0)), 0);

                    return {
                        "ລ/ດ": index + 1,
                        "ລະຫັດ CF": firstOrder?.cfMessage || "",
                        // "ຮູບ": "", // stock?.image ? imageRender(stock?.image) : "",
                        "ຊື່ສິນຄ້າ": stock?.name || firstOrder?.productName || "",
                        "ລະຫັດ CF ": firstOrder?.cfMessage || "", 
                        "QTY": count,
                        "ລາຄາ": price,
                        "KIP": totalPrice
                    };
                });

                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(dataToExport);

                // Set column widths
                const wscols = [
                    { wch: 5 },  // ລ/ດ
                    { wch: 15 }, // ລະຫັດ CF
                    { wch: 10 }, // ຮູບ
                    { wch: 40 }, // ຊື່ສິນຄ້າ
                    { wch: 15 }, // ລະຫັດ CF
                    { wch: 8 },  // QTY
                    { wch: 15 }, // ລາຄາ
                    { wch: 15 }  // KIP
                ];
                worksheet['!cols'] = wscols;
                
                // Set A4 paper size (9)
                worksheet['!pageSetup'] = { paperSize: 9, orientation: 'portrait' };

                XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");
                XLSX.writeFile(workbook, `ສະຫຼຸບຍອດຂາຍ ${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
            }
        } catch (error) {
            console.error("Error exporting excel:", error);
        }
    };

    return (
        <div>
            <div style={{ height: 10 }} />
            <br />
            <div style={{ background: "#fff", borderRadius: 5, padding: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
                    <p style={{ fontSize: 20, margin: 0 }}>ລາຍການສິນຄ້າທີ່ຂາຍໄດ້</p>
                    <Button 
                        variant="success" 
                        onClick={handleExportExcel}
                        disabled={loadingAllOrders}
                        style={{ background: "#28a745", borderColor: "#28a745" }}
                    >
                        {loadingAllOrders ? <Spinner size="sm" animation="border" /> : "ບັນທຶກເປັນ Excel"}
                    </Button>
                </div>
                <Table responsive className="staff-table-list borderless table-hover">
                    <thead style={{ background: "#F1F1F1" }}>
                        <tr style={{ whiteSpace: 'nowrap' }}>
                            <th style={{ borderBottom: "none" }}>ລ/ດ</th>
                            <th style={{ borderBottom: "none" }}>ຮູບ</th>
                            <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ</th>
                            <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
                            <th style={{ borderBottom: "none" }}>ຂາຍໄດ້</th>
                            <th style={{ borderBottom: "none" }}>ລາຄາ</th>
                            <th style={{ borderBottom: "none" }}>ລວມເງິນ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {liveProductSummary && liveProductSummary?.map((lStock, index) => {
                            return <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                                <td>{index + 1}</td>
                                <td><img src={imageRender(lStock?.stock?.image)} style={{
                                    borderRadius: "50%",
                                    height: 50,
                                    width: 50,
                                }} /></td>
                                <td>
                                    {lStock?.stock?.name}
                                </td>
                                <td>{lStock?.cfMessage}</td>
                                <td>{lStock?.count ?? 1}</td>
                                <td>{thousandSeperate(lStock?.price ?? lStock?.stock?.price)}</td>
                                <td>{thousandSeperate(lStock?.totalPrice ?? 0)} {lStock?.currency}</td>
                            </tr>
                        })}
                    </tbody>
                </Table>


                <PaginationsV1
                    count={totalOrder}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    pageAll={pageAll}
                    onPageChange={handleChangePage}
                />

            </div >

            <div style={{ height: 100 }} />
        </div >
    );
}

export default LiveDetailSummary;